import { render, staticRenderFns } from "./signItem.vue?vue&type=template&id=1ca7c365&scoped=true&"
import script from "./signItem.vue?vue&type=script&lang=js&"
export * from "./signItem.vue?vue&type=script&lang=js&"
import style0 from "./signItem.vue?vue&type=style&index=0&id=1ca7c365&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7c365",
  null
  
)

export default component.exports